export default __webpack_public_path__ + "static/media/videoBK.fe0f99a4.mp4";